/**
 * Устанавливает корректный класс стилей без undefined и false
 * @param args - Стили, которые должны быть применены к элементу 
 * или условие для этого стиля
 * @returns Строка, которая вставляется в className
 * @example setClass(isError && 'error', 'gray') -> 'error gray' | 'gray'
 */
export const setClass = (...args: (string | boolean)[]) => {
  const className = args.filter((elem) => elem !== undefined && elem !== false).join(' ');
  return className.length !== 0 ? className + ' ' : className;
};
